/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMemberStatus } from './WebApiModelsEnumerationTypesMemberStatus';
import {
    WebApiModelsEnumerationTypesMemberStatusFromJSON,
    WebApiModelsEnumerationTypesMemberStatusFromJSONTyped,
    WebApiModelsEnumerationTypesMemberStatusToJSON,
} from './WebApiModelsEnumerationTypesMemberStatus';
import type { WebApiModelsEnumerationTypesMemberType } from './WebApiModelsEnumerationTypesMemberType';
import {
    WebApiModelsEnumerationTypesMemberTypeFromJSON,
    WebApiModelsEnumerationTypesMemberTypeFromJSONTyped,
    WebApiModelsEnumerationTypesMemberTypeToJSON,
} from './WebApiModelsEnumerationTypesMemberType';

/**
 * 
 * @export
 * @interface WebApiAdminDtoAdminMemberSearchResultDto
 */
export interface WebApiAdminDtoAdminMemberSearchResultDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoAdminMemberSearchResultDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoAdminMemberSearchResultDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoAdminMemberSearchResultDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoAdminMemberSearchResultDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoAdminMemberSearchResultDto
     */
    uniqueId?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberType}
     * @memberof WebApiAdminDtoAdminMemberSearchResultDto
     */
    memberType?: WebApiModelsEnumerationTypesMemberType;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberStatus}
     * @memberof WebApiAdminDtoAdminMemberSearchResultDto
     */
    status?: WebApiModelsEnumerationTypesMemberStatus;
}

/**
 * Check if a given object implements the WebApiAdminDtoAdminMemberSearchResultDto interface.
 */
export function instanceOfWebApiAdminDtoAdminMemberSearchResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoAdminMemberSearchResultDtoFromJSON(json: any): WebApiAdminDtoAdminMemberSearchResultDto {
    return WebApiAdminDtoAdminMemberSearchResultDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoAdminMemberSearchResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoAdminMemberSearchResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'uniqueId': !exists(json, 'uniqueId') ? undefined : json['uniqueId'],
        'memberType': !exists(json, 'memberType') ? undefined : WebApiModelsEnumerationTypesMemberTypeFromJSON(json['memberType']),
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesMemberStatusFromJSON(json['status']),
    };
}

export function WebApiAdminDtoAdminMemberSearchResultDtoToJSON(value?: WebApiAdminDtoAdminMemberSearchResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'uniqueId': value.uniqueId,
        'memberType': WebApiModelsEnumerationTypesMemberTypeToJSON(value.memberType),
        'status': WebApiModelsEnumerationTypesMemberStatusToJSON(value.status),
    };
}

